import { IUserAccountStore } from '../../index'
import { INotificationPageAccepted } from '../../../../actions/notification/loadMore'

export default function(
  store: IUserAccountStore,
  action: INotificationPageAccepted,
): IUserAccountStore {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      count: action.notifications.count,
      countNotRead: action.notifications.countNotRead,
      countNotSeen: action.notifications.countNotSeen,
      hasMore: action.hasMore,
      isLoading: false,
      items: [
        ...store.notifications.items.map(
          not =>
            action.notifications.items.find(
              newNot => String(newNot.id) === String(not.id),
            ) || not,
        ),
        ...action.notifications.items.filter(
          newNot =>
            !store.notifications.items.find(
              not => String(not.id) === String(newNot.id),
            ),
        ),
      ].filter(not => !action.ids.find(id => String(not.id) === String(id))),
    },
  }
}
